import * as React from "react";
import { useMemo } from "react";
import Spinner from "components/common/Spinner";
import useCurrentUser from "hooks/useCurrentUser";
import { isPermitted } from "util/PermissionsMixin";
import { useGetUsersNTeams } from "security-app/hooks/useSecurityEventsAPI";
import { adminAssignee } from "security-app/components/SecurityEvents/Alerts/hooks/useOwnerTitles";
import AssigneeCell from "../../common/AssigneeCell";
const LoadOwner = ({ owner }) => {
  const { usersNTeams, loadingUsersNTeams } = useGetUsersNTeams();
  const currentUser = useCurrentUser();
  const resolvedAssignee = useMemo(() => {
    const admin = adminAssignee(owner);
    if (admin) return admin;
    const match = usersNTeams.find((entry) => entry.id === owner);
    if (match) {
      return { id: match.id, label: match.name, type: match.type === "Team" ? "team" : "user" };
    }
    if (currentUser.id === owner) {
      return { id: currentUser.id, label: currentUser.fullName, type: "user" };
    }
    return void 0;
  }, [usersNTeams, currentUser.id, currentUser.fullName, owner]);
  if (loadingUsersNTeams) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  if (resolvedAssignee) {
    return /* @__PURE__ */ React.createElement(AssigneeCell, { assignee: resolvedAssignee });
  }
  if (isPermitted(currentUser.permissions, "users:list")) {
    return /* @__PURE__ */ React.createElement("i", null, owner, " (deleted)");
  }
  return /* @__PURE__ */ React.createElement("i", null, "Assigned");
};
const OwnerCell = ({ owner }) => {
  if (owner === null || owner === "null") {
    return /* @__PURE__ */ React.createElement("i", null, "none");
  }
  return /* @__PURE__ */ React.createElement(LoadOwner, { owner });
};
export default OwnerCell;
